/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { IonButton, IonCol, IonContent, IonGrid, IonIcon, IonImg, IonPage, IonRow, useIonToast } from '@ionic/react';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useHistory } from 'react-router';
import moment from 'moment-timezone';
import { compareDesc, parseISO } from 'date-fns';

import { AuthService, ICasinoAccess, ICasinoLinkedAccount } from 'services/auth';
import { CasinoService } from 'services/casino';
import { FilterTypeEnum, checkProUser, S3_PROFILE_BASE } from 'common/common';
import { featureFlags } from 'config/config';

import { ICasinoSchema, ICasinoSchemaWithAccess } from 'appRedux/models/casinoModels';
import { ReduxCommandCreator } from 'appRedux/actions';
import { AUTH_STATE } from 'appRedux/types/reduxTypes';
import { IFilterState, IState, IUserInfo, useAppSelector } from 'appRedux/createStore';
import { CasinoReduxCommandCreator } from 'appRedux/actions/casinoCommandCreator';
import { FilterReduxCommandCreator } from 'appRedux/actions/filterCommandCreator';
import { FloormapReduxCommandCreator } from 'appRedux/actions/floormapCommandCreator';
import { IUserSubscription } from '@interfaces/userSubscription';

import { checkmarkCircle, locateOutline } from 'ionicons/icons';

import SmartLoading from 'components/SmartLoading';
import { CasinoCard } from 'components/CasinoCard.tsx/CasinoCard';
import { lastValueFrom } from 'rxjs';
import CasinoNavBar from 'components/CasinoNavBar';
import { SlotReduxCommandCreator } from 'appRedux/actions/slotCommandCreator';
import useLocalStorage from 'common/reactHooks/useLocalStorage';
import LegalDisclaimer from '../LegalDisclaimer';
import { casinoIdListEnum } from 'common/commonEnum';
import { SlotHistoryReduxCommandCreator } from 'appRedux/actions/slotHistoryCommandCreator';
import { SlotCompareReduxCommandCreator } from 'appRedux/actions/slotCompareCommandCreator';
import { useUserLocation } from 'common/reactHooks/useUserLocation';
import { distanceInMiles, formatMiles, getCasinoLatLng, sortCasinosByDistance } from 'common/geo';
import NearbyCasinosMap from 'components/NearbyCasinosMap/NearbyCasinosMap';
import { saveState } from 'localStorage';
import {
  clearResumeLastViewedCasinoFlag,
  consumeResumeLastViewedCasino,
  isForceSelectCasinoRequest,
  normalizeCasinoId,
  peekResumeLastViewedCasino,
  resolveLastViewedResume,
} from 'lib/lastViewedCasino';
import {
  clearLoginCasinoReveal,
  decideCasinoEntryReveal,
  hasShownRandomOutcomesThisSession,
  markLoginCasinoReveal,
  markRandomOutcomesShownThisSession,
  shouldShowChooseCasinoDisclaimer,
  ResumeOutcome,
} from 'lib/loginCasinoReveal';
import { clearLinkPlayerDue, isLinkPlayerDrawerFlow, markLinkPlayerDue } from 'lib/linkPlayerFlow';
import { raiseSessionLimit } from 'lib/sessionExpiry';
import { getExploreDefaults } from 'lib/exploreDefaults';
import { isInsightCasinoSchema } from 'services/insightCasino';

const slotCheckCasinoId = parseInt(__SLOTCHECK_ID__);
const globalProCasinoId = slotCheckCasinoId;

export const ChooseCasinos: FC = () => {
  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const casinoSvc = new CasinoService();
  const auth = new AuthService();
  const history = useHistory();
  const dispatch = useDispatch();
  const reduxStore = useStore<IState>();
  const commands = ReduxCommandCreator(dispatch);
  const casinoCommands = CasinoReduxCommandCreator(dispatch);
  const floormapCommand = FloormapReduxCommandCreator(dispatch);
  const historyCommands = SlotHistoryReduxCommandCreator(dispatch);
  const slotCommands = SlotReduxCommandCreator(dispatch);
  const slotCompareCommandCreator = SlotCompareReduxCommandCreator(dispatch);

  const clearState = () => {
    historyCommands.ClearSlotHistory();
    slotCompareCommandCreator.clearSlots();
    slotCommands.ClearSelectedSlots();
    floormapCommand.SetClearMapValues();
  };
  // Separate useLocalStorage instances do not sync across components. LegalDisclaimer
  // writes `true` on Yes into its own hook state + localStorage (kept as a record of
  // consent); this parent mirrors it. Whether Random Outcomes shows is decided by the
  // once-per-login-session marker (lib/loginCasinoReveal), not by this flag.
  const [, setHasAgreedToLegalDisclaimer] = useLocalStorage<boolean>('legalDisclaimer', false);
  const [showModal, setShowModal] = useState(false);

  // 'pending' until the resume effect below decides: 'entered' (open the last casino; the
  // Random Outcomes drawer is shown over it by Home) or 'selection' (stay on this screen).
  const [resumeOutcome, setResumeOutcome] = useState<ResumeOutcome>('pending');

  // The modal follows the same once-per-login-session rule as the drawer and never shows
  // twice in a session: the first casino entry shows the drawer in Explore, so the modal
  // only covers a forced Select Casino visit before Random Outcomes was shown.
  useEffect(() => {
    const forceSelect = isForceSelectCasinoRequest(
      history.location.search,
      history.location.state as { forceSelect?: boolean } | null
    );
    if (
      shouldShowChooseCasinoDisclaimer({
        shownThisSession: hasShownRandomOutcomesThisSession(appUserPk),
        forceSelect,
        resumeOutcome,
      })
    ) {
      setShowModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resumeOutcome]);

  const handleLegalDisclaimerClose = () => {
    // onClose is only invoked from LegalDisclaimer after "Yes, I agree"
    // (No → logout). Counts as this session's Random Outcomes: no drawer on the next pick.
    setHasAgreedToLegalDisclaimer(true);
    markRandomOutcomesShownThisSession(appUserPk);
    setShowModal(false);
  };

  const { aliasName, aliasInitial, aliasInitial2, firstName, avatarId, avatarBgId, isCasinoAccount, proCasinoId, proCasinoSubscription, appUserPk } =
    useAppSelector((state) => state.app.persistedState.userInfo) as IUserInfo & {
      casinoId?: number;
    };

  const isInvalidAlias = (name: string | undefined) =>
    !name || name.toLowerCase().includes('invalid');

  const welcomeName = !isInvalidAlias(aliasName) ? aliasName : (firstName || '');
  const casinoLinkedAccounts = useAppSelector(
    (state) => state.app.persistedState.linkPlayerState?.casinoLinkedAccounts
  ) as ICasinoLinkedAccount[];

  const casinoSchema = useAppSelector(
    (state) => state.app.persistedState.casinoSchema
  ) as ICasinoSchema | null;

  const [presentToast] = useIonToast();

  // Start true so the resume effect cannot consume the session flag against an
  // empty catalog before fetchData has run (isLoading was previously false).
  const [isLoading, setIsLoading] = useState(true);
  const [catalogLoaded, setCatalogLoaded] = useState(false);
  const filterCommandCreator = FilterReduxCommandCreator(dispatch);

  const [casinos, setCasinos] = useState<ICasinoSchemaWithAccess[]>([]);
  const [recentCasinos, setRecentCasinos] = useState<ICasinoSchemaWithAccess[]>([]);
  // Server-sourced last-visited casino (most recent lastVisit, primary included) so the
  // "last selected" highlight survives logout / new devices, not just same-device localStorage.
  const [lastVisitedCasinoId, setLastVisitedCasinoId] = useState<number | null>(null);
  const [otherCasinos, setOtherCasinos] = useState<ICasinoSchemaWithAccess[]>([]);

  const [comingSoonCasinos, setComingSoonCasinos] = useState<ICasinoSchema[]>([]);

  // Nearby casinos (behind the `nearbyCasinos` feature flag): location is only
  // requested from the "Find casinos near me" button (or silently on later
  // visits once the user has opted in). With the flag off, userLocation stays
  // null so the list keeps its current order and cards show no distance.
  const isNearbyCasinosEnabled = featureFlags.nearbyCasinos;
  const { coords: userLocation, status: locationStatus, requestLocation } =
    useUserLocation(isNearbyCasinosEnabled);
  // The whole nearby feature stays hidden until casino docs carry coordinates.
  const hasLocatedCasinos = useMemo(
    () => isNearbyCasinosEnabled && casinos.some((c) => getCasinoLatLng(c)),
    [isNearbyCasinosEnabled, casinos]
  );
  const nearestCasinoId = useMemo(() => {
    if (!userLocation) {
      return undefined;
    }
    const [nearest] = sortCasinosByDistance(casinos, userLocation);
    return nearest && getCasinoLatLng(nearest) ? nearest.casinoId : undefined;
  }, [casinos, userLocation]);

  const sortByUserDistance = <T extends ICasinoSchema>(list: T[]): T[] =>
    userLocation ? sortCasinosByDistance(list, userLocation) : list;

  const getDistanceLabel = (casino: ICasinoSchema): string | undefined => {
    const coords = getCasinoLatLng(casino);
    return userLocation && coords ? formatMiles(distanceInMiles(userLocation, coords)) : undefined;
  };

  const addAccessInfoToCasino = (
    casinoList: ICasinoSchema[],
    casinoAccess: ICasinoAccess
  ): ICasinoSchemaWithAccess[] => {
    return casinoList.flatMap((casinoInfo) => {
      if (!casinoInfo) {
        return [];
      }

      const casinoId = casinoInfo.casinoId;
      // eslint-disable-next-line security/detect-object-injection
      const casinoAccessInfo = casinoAccess[casinoId];

      return [
        {
          ...casinoInfo,
          // hasAccess: casinoAccessInfo?.hasAccess || false,
          // timeLeft: casinoAccessInfo?.timeLeft || 0,
          hasAccess: true,
          timeLeft: casinoAccessInfo?.timeLeft || 0,
        },
      ];
    });
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      setIsLoading(true);

      try {
        const casinoResponse = await lastValueFrom(casinoSvc.GetAllCasinos());

        if (casinoResponse && isMounted) {
          const filteredCasinos = casinoResponse.DataSet.filter(
            (casinoInfo) => casinoInfo.casinoId !== slotCheckCasinoId
          );

          let activeCasinos: ICasinoSchema[] = [];
          if (isCasinoAccount) {
            // If casino account, include all active casinos (regardless of coming soon)
            activeCasinos = filteredCasinos.filter((casinoInfo) => casinoInfo.isactive);
          } else {
            // If not casino account, only include active casinos that are not coming soon
            activeCasinos = filteredCasinos.filter(
              (casinoInfo) => casinoInfo.isactive && !casinoInfo.isComingSoon
            );
          }

          // Coming soon casinos: if isCasinoAccount, don't filter; else, filter as before
          const comingSoonCasinos = isCasinoAccount
            ? []
            : filteredCasinos.filter(
                (casinoInfo) => casinoInfo.isactive && casinoInfo.isComingSoon
              );

          setComingSoonCasinos(comingSoonCasinos);

          const activeCasinoIds = [...activeCasinos, ...comingSoonCasinos].map(
            (casinoInfo) => casinoInfo.casinoId
          );

          // Fetch user info for active casinos
          if (activeCasinoIds && activeCasinoIds.length > 0) {
            const userInfo = await lastValueFrom(auth.GetUserInfo(activeCasinoIds));
            if (userInfo && isMounted) {
              const subscriptionList = Array.isArray(userInfo.user.subscription)
                ? userInfo.user.subscription
                : userInfo.user.subscription
                ? [userInfo.user.subscription]
                : [];

              const subscriptions = subscriptionList;

              const globalSubscription = subscriptions.find((sub) => {
                const subStatus = sub.subscriptionData?.status;
                const currentPeriodEnd = sub.subscriptionData?.current_period_end;
                return (
                  sub.casinoId === globalProCasinoId && checkProUser(subStatus, currentPeriodEnd)
                );
              });

              const activeSubscription = subscriptions.find((sub) => {
                const subStatus = sub.subscriptionData?.status;
                const currentPeriodEnd = sub.subscriptionData?.current_period_end;
                return checkProUser(subStatus, currentPeriodEnd);
              });

              const proSubscription = globalSubscription || activeSubscription;
              const isProUser = Boolean(proSubscription);
              const isCasinoAccount = userInfo.user.info?.isCasinoAccount || false;
              commands.SetIsCasinoAccount(isCasinoAccount);

              const casinoIdSub = proSubscription?.casinoId;
              const isProMember =
                isCasinoAccount || casinoIdSub === globalProCasinoId || isProUser;
              

              const userLevelPayload = {
                isProUser: isProMember,
                aliasInitial: userInfo.user.info.aliasInitial,
                aliasInitial2: userInfo.user.info.aliasInitial2,
                aliasName: userInfo.user.info.aliasName,
                proCasinoSubscription: false,
              } as {
                isProUser: boolean;
                aliasInitial: string;
                aliasInitial2: string;
                aliasName: string;
                proCasinoId?: number;
                proCasinoSubscription?: boolean;
              };

              if (proSubscription) {
                userLevelPayload.proCasinoId = casinoIdSub;
                userLevelPayload.proCasinoSubscription = isProUser;
              }

              commands.SetUserLevel(userLevelPayload);
              if (userInfo.user.info.avatarId) {
                commands.SetUserAvatar(
                  userInfo.user.info.avatarId,
                  userInfo.user.info.avatarBgId ?? 1
                );
              }
              casinoCommands.SetLinkedCasinos({
                casinoLinkedAccounts: userInfo.user.linkedAccounts,
              });

              const {
                primaryCasino = null,
                recentCasinos = [],
                otherCasinos = [],
              } = userInfo.user.userCasinoList || {};

              const { casinoAccess } = userInfo.user;

              if (recentCasinos) {
                // Highlight helper only (resume uses persisted casinoSchema).
                const mostRecentlyVisited = [...recentCasinos]
                  .filter((casino) => casino?.lastVisit)
                  .sort((a, b) => compareDesc(parseISO(a.lastVisit!), parseISO(b.lastVisit!)))[0];

                if (mostRecentlyVisited?.casinoId) {
                  setLastVisitedCasinoId(mostRecentlyVisited.casinoId);
                }

                let recentCasinoList = recentCasinos;

                if (primaryCasino?.casinoId) {
                  recentCasinoList = recentCasinos.filter(
                    (casino) => casino.casinoId !== primaryCasino.casinoId
                  );
                }

                const sortedCasinos = recentCasinoList.sort((a, b) => {
                  if (a?.lastVisit && b?.lastVisit) {
                    return compareDesc(parseISO(a.lastVisit), parseISO(b.lastVisit));
                  }

                  return 0;
                });

                recentCasinos &&
                  setRecentCasinos(addAccessInfoToCasino(sortedCasinos, casinoAccess));
              }

              if (activeCasinos) {
                setCasinos(addAccessInfoToCasino(activeCasinos, casinoAccess));
              }

              if (primaryCasino) {
                const primaryCasinoWithAccess = addAccessInfoToCasino(
                  [primaryCasino],
                  casinoAccess
                );
                commands.SetUserPrimaryCasino(primaryCasinoWithAccess);
              }

              if (otherCasinos) {
                const otherWithoutIsComingSoon = otherCasinos.filter(
                  (casinoInfo) => casinoInfo.isactive && !casinoInfo.isComingSoon
                );

                otherCasinos &&
                  setOtherCasinos(addAccessInfoToCasino(otherWithoutIsComingSoon, casinoAccess));
              }
            }
          }
        }
      } catch (error) {
        if (isMounted) {
          presentToast({
            position: 'top',
            duration: 5000,
            color: 'danger',
            message: 'Failed to retrieve casino information.',
          }).catch(() => null);
        }
      } finally {
        if (isMounted) {
          setCatalogLoaded(true);
          setIsLoading(false);
        }
      }
    };

    fetchData().catch((error) => {
      console.log(error);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const updateUserPreference = (reqParam: IFilterState[] | undefined) => {
    if (reqParam === undefined) {
      filterCommandCreator.ResetAllFilters();
    } else {
      const filters = reqParam[0];

      // hottestSlots is intentionally not restored from backend preferences —
      // the home map always loads with the Explore defaults (lib/exploreDefaults:
      // applicationConfigurations, fallback Hottest + 7d for every casino).

      if (filters && FilterTypeEnum && FilterTypeEnum.leaderboard in filters) {
        filterCommandCreator.SetFilterOptions(FilterTypeEnum.leaderboard, {
          ...filters[FilterTypeEnum.leaderboard],
        });
      }
      if (filters && FilterTypeEnum && FilterTypeEnum.jackpot in filters) {
        filterCommandCreator.SetFilterOptions(FilterTypeEnum.jackpot, {
          ...filters[FilterTypeEnum.jackpot],
        });
      }
      if (filters && FilterTypeEnum && FilterTypeEnum.myplay in filters) {
        filterCommandCreator.SetFilterOptions(FilterTypeEnum.myplay, {
          ...filters[FilterTypeEnum.myplay],
        });
      }
    }
  };

  const getUserSubscriptionAndPreferences = (
    subscriptions: IUserSubscription[],
    preference: IFilterState[] | undefined,
    appUserPk: string,
    selectedCasinoId: number,
    isInsightCasino: boolean
  ) => {
    const globalSubscription = subscriptions.find((sub) => {
      const subStatus = sub.subscriptionData?.status;
      const currentPeriodEnd = sub.subscriptionData?.current_period_end;
      const isPro = checkProUser(subStatus, currentPeriodEnd);
      return sub.casinoId === globalProCasinoId && isPro;
    });

    const casinoSubscription = subscriptions.find((sub) => {
      const subStatus = sub.subscriptionData?.status;
      const currentPeriodEnd = sub.subscriptionData?.current_period_end;
      const isPro = checkProUser(subStatus, currentPeriodEnd);
      return sub.casinoId === selectedCasinoId && isPro;
    });

    const subscription = globalSubscription || casinoSubscription;

    if (subscription) {
      const { subscriptionData, customerData } = subscription;
      const customerId = customerData?.id;
      const planId = subscriptionData?.plan?.id;
      const subscriptionId = subscriptionData?.id;
      const currentPeriodEnd = subscriptionData?.current_period_end;
      const canceledAt = subscriptionData?.canceled_at;
      const subscriptionActive = subscriptionData?.status;
      const isProUser =
        subscription.casinoId === globalProCasinoId
          ? true
          : checkProUser(subscriptionActive, currentPeriodEnd);

      if (isProUser) {
        preference && updateUserPreference(preference);
      } else {
        updateUserPreference(undefined);
      }

      commands.SetUserLevel({
        level: planId,
        customer_id: customerId,
        subscription_id: subscriptionId,
        current_period_end: currentPeriodEnd,
        canceled_at: canceledAt,
        isProUser: isCasinoAccount || subscription.casinoId === globalProCasinoId ? true : isProUser,
        appUserPk: appUserPk,
      });
    } else {
      updateUserPreference(undefined);
      commands.SetUserLevel({
        level: '',
        customer_id: '',
        subscription_id: '',
        isProUser: isCasinoAccount ? true : false,
      });
    }

    // Same Explore defaults MapStats applies on casino entry (one shared helper).
    filterCommandCreator.SetFilterOptions(
      FilterTypeEnum.hottestSlots,
      getExploreDefaults(isInsightCasino)
    );
  };

  const onClickCasino = (casinoDetail: ICasinoSchema) => {
    // Coming Soon stays in Upcoming launches; preview members may still enter.
    if (!isCasinoAccount && casinoDetail.isComingSoon && !casinoDetail.isPreview) {
      return;
    }
    // SetCasinoSchema (below) updates persisted casinoSchema — last-viewed on this device.

    if (isMountedRef.current) {
      setIsLoading(true);
    }
    const { casinoTimezoneNew, casinoId } = casinoDetail;
    // Random Outcomes: once per login session, on the FIRST casino entry (login reopen or
    // manual pick). Hand it to Home before navigating; later entries skip it.
    const entryReveal = decideCasinoEntryReveal(hasShownRandomOutcomesThisSession(appUserPk));
    if (entryReveal) {
      markLoginCasinoReveal(entryReveal);
    } else {
      clearLoginCasinoReveal();
    }
    // A Link Player prompt is only due for THIS entry (Version 2 casinos, set below).
    clearLinkPlayerDue();
    // LinkPlayerflowVersion 2 / '2': Link Player ID opens in the Explore drawer instead of
    // the full-screen /auth/link-player step. 1, '1', missing or anything else: as today.
    const useLinkPlayerDrawer = isLinkPlayerDrawerFlow(casinoDetail);
    const goToLinkPlayer = () => {
      if (useLinkPlayerDrawer) {
        markLinkPlayerDue(casinoId);
        history.push('/tabs/home');
      } else {
        history.push(`/auth/link-player/${casinoId}`);
      }
    };
    casinoCommands.SetCasinoSchema(casinoDetail);
    // Persist immediately — store.subscribe saveState is throttled to 1s, so a
    // fast logout after select could otherwise lose casinoSchema for resume.
    saveState(reduxStore.getState().app.persistedState);
    // Signal a fresh casino entry so the home/map view resets to its defaults
    // (lib/exploreDefaults: fallback Hottest Slots + 7 days for every casino,
    // + top-two heat-map levels) even when re-selecting
    // the casino already in view. Without this, re-selecting the same casino
    // leaves kpCasinoPk unchanged so the reset never runs and the heat-map
    // filter stays at the "show all" state left by clearState().
    casinoCommands.MarkCasinoEntry();
    moment.tz.setDefault(casinoTimezoneNew);

    auth.GetMe(casinoId).subscribe({
      next(data) {
        if (data?.user) {
          const { preference, linkedAccounts, hasAccess } = data.user;
          const {
            aliasInitial2,
            aliasInitial,
            aliasName,
            firstName,
            lastName,
            emailAddress,
            appUserPk: appUserFk,
            isCasinoAccount,
            showLoadingReels,
          } = data.user.info;

          const aliasInformation: Partial<IUserInfo> = {
            aliasInitial: aliasInitial,
            aliasInitial2: aliasInitial2,
            aliasName: aliasName,
          };
          commands.SetTourState(data.user.info?.hasCompletedOnboarding as boolean);
          commands.SetUserPrivacy(data.user.info.isPublicVisible);
          commands.SetUserAlias({
            ...aliasInformation,
          });
          if (data.user.info.avatarId) {
            commands.SetUserAvatar(data.user.info.avatarId, data.user.info.avatarBgId ?? 1);
          }
          const userInformation: Partial<IUserInfo> = {
            firstName: firstName,
            lastName: lastName,
            emailAddress: emailAddress,
            isCasinoAccount,
            // Refreshed on every casino entry (GetMe), so an admin change to
            // users.showLoadingReels shows up without logging out.
            showLoadingReels: showLoadingReels ?? null,
          };
          commands.SetUserInformation({
            ...userInformation,
          });
          commands.SetPlayerCardInfo(data.user.playerCardInfo ?? null);
          // Inactivity logout: a link verified during the session lifts 1h to 4h.
          raiseSessionLimit(linkedAccounts);
          if (data.user.subscriptions) {
            getUserSubscriptionAndPreferences(
              data.user.subscriptions,
              preference as IFilterState[],
              data.user.info?.appUserPk,
              casinoId,
              isInsightCasinoSchema(casinoDetail)
            );
          } else {
            commands.SetUserLevel({
              level: '',
              customer_id: '',
              subscription_id: '',
              isProUser: isCasinoAccount ? true : false,
            });
          }

          if (!hasAccess && !isCasinoAccount) {
            goToLinkPlayer();
            return;
          }

          if (isCasinoAccount) {
            history.push('/tabs/home');
            return;
          }
          if (linkedAccounts && linkedAccounts.length > 0) {
            const casinoItem = linkedAccounts.find(
              (item: ICasinoLinkedAccount) => item.casinoId === casinoId
            );
            const isUnverified = casinoItem?.verification === 'unverified';
            const isPlayerLinked = Boolean(casinoItem) && !isUnverified;
            const linkedCasinoId = isPlayerLinked ? casinoItem?.casinoId : null;

            if (isUnverified) {
              presentToast({
                position: 'top',
                duration: 5000,
                color: 'danger',
                message:
                  'Player ID is unverified and the data provided did not match. Please update your Player ID and Birthday.',
              }).catch(() => null);
            }

            casinoCommands.SetLinkedCasinos({
              casinoLinkedAccounts: isPlayerLinked ? linkedAccounts : [],
              isPlayerLinked,
              linkedCasinoId,
            });

            if (isPlayerLinked) {
              history.push('/tabs/home');
            } else {
              goToLinkPlayer();
            }
          } else {
            casinoCommands.SetLinkedCasinos({
              casinoLinkedAccounts: [],
              isPlayerLinked: false,
              linkedCasinoId: null,
            });
            goToLinkPlayer();
          }

          casinoSvc.UpdateRecentCasinoID(String(casinoId), appUserFk).subscribe();
        }
      },
      error(err) {
        commands.SetUserInfo('', '');
        commands.SetAuthState(AUTH_STATE.SIGN_IN);
      },
      complete() {
        if (isMountedRef.current) {
          setIsLoading(false);
        }
      },
    });
  };

  // Post-login only: resume flag set by SignIn / CasinoSignIn / Emulate / UserConfirm.
  // Side-menu / header logo pass ?forceSelect=1 → clear flag and stay on selection.
  // Last viewed = persisted casinoSchema (survives logout via CLEAR_STORE + clearState).
  // Do NOT consume the session flag until the casino catalog has finished loading —
  // otherwise an empty first paint permanently burns the resume (Miller bug).
  // The Random Outcomes disclaimer does NOT gate the resume any more: we open the last
  // casino as soon as the catalog is ready and Home presents the disclaimer as a locked
  // drawer over it (see lib/loginCasinoReveal + components/RandomOutcomesDrawer). That is
  // decided in onClickCasino for every entry: once per login session, first entry only.
  const resumeHandledRef = useRef(false);
  useEffect(() => {
    if (resumeHandledRef.current) return;

    const forceSelect = isForceSelectCasinoRequest(
      history.location.search,
      history.location.state as { forceSelect?: boolean } | null
    );
    const accessible = [...casinos, ...comingSoonCasinos];
    const action = resolveLastViewedResume({
      forceSelect,
      catalogLoaded,
      isLoading,
      resumeFlagPresent: peekResumeLastViewedCasino(),
      persistedCasinoId: casinoSchema?.casinoId,
      accessibleCasinos: accessible,
    });

    if (action.type === 'wait') return;

    if (action.type === 'skip') {
      if (forceSelect) {
        clearResumeLastViewedCasinoFlag();
      }
      resumeHandledRef.current = true;
      setResumeOutcome('selection');
      return;
    }

    // enter | give_up — catalog is ready; consume the one-shot flag now.
    consumeResumeLastViewedCasino();
    resumeHandledRef.current = true;

    if (action.type === 'give_up') {
      setResumeOutcome('selection');
      return;
    }

    const target = accessible.find(
      (c) => normalizeCasinoId(c.casinoId) === action.casinoId
    );
    if (target) {
      // onClickCasino hands the Random Outcomes reveal to Home (first entry of this login
      // session) BEFORE navigating, the same as a manual pick.
      setResumeOutcome('entered');
      onClickCasino(target);
    } else {
      setResumeOutcome('selection');
    }
    // onClickCasino is stable enough for a one-shot resume; omit from deps to avoid re-fire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    catalogLoaded,
    isLoading,
    casinoSchema?.casinoId,
    casinos,
    comingSoonCasinos,
    history.location.search,
    history.location.state,
  ]);

  const renderTitleContainer = (title: string, showCheck = false, extraClass = '') => {
    return (
      <div className={`title-container${extraClass ? ` ${extraClass}` : ''}`}>
        {showCheck && <IonIcon icon={checkmarkCircle} className="title-check-icon" />}
        <div role="heading" aria-level={2} className="title">
          {title}
        </div>
      </div>
    );
  };

  const renderCasinoItem = (casino: ICasinoSchemaWithAccess, key: string, selected = false) => {
    const { displayName, casinoId, logos, website, address, timeLeft, hasAccess } = casino;
    // If isCasinoAccount, never show as coming soon
    const showIsComingSoon = isCasinoAccount ? false : casino.isComingSoon;

    let isPlayerLinked = false;
    if (casinoLinkedAccounts) {
      isPlayerLinked = casinoLinkedAccounts.some((account) => account.casinoId === casinoId);
    }

    if (isCasinoAccount) {
      isPlayerLinked = true;
    }

    return (
      <IonRow data-testid="choose-casino-item" key={key}>
        <IonCol size="12">
          <CasinoCard
            key={casinoId?.toString()}
            actionText=""
            logoIcon={logos.navBar}
            name={displayName}
            website={website}
            address={address.displayAddress}
            onActionClick={() => {
              clearState();
              onClickCasino(casino);
            }}
            isComingSoon={showIsComingSoon}
            isPreview={Boolean(casino.isPreview)}
            isPlayerLinked={isPlayerLinked}
            hasAccess={hasAccess}
            timeLeft={timeLeft}
            proCasinoSubscription={proCasinoSubscription}
            casinoId={casinoId}
            isSelected={selected}
            distanceLabel={getDistanceLabel(casino)}
            isNearest={casinoId === nearestCasinoId}
          />
        </IonCol>
      </IonRow>
    );
  };

  const renderNearbySection = () => {
    if (!hasLocatedCasinos) {
      return null;
    }

    if (userLocation) {
      return (
        <div className="nearby-casinos">
          {renderTitleContainer('Casinos Near You')}
          <NearbyCasinosMap
            casinos={casinos}
            userLocation={userLocation}
            nearestCasinoId={nearestCasinoId}
            onSelectCasino={(casino) => {
              clearState();
              onClickCasino(casino);
            }}
          />
        </div>
      );
    }

    const isLocating = locationStatus === 'locating';
    return (
      <div className="nearby-casinos nearby-casinos--prompt">
        <IonButton
          className="nearby-casinos__button"
          expand="block"
          disabled={isLocating}
          onClick={() => {
            requestLocation().catch(() => null);
          }}
          data-testid="use-my-location"
        >
          <IonIcon slot="start" icon={locateOutline} />
          {isLocating ? 'Finding your location…' : 'Find casinos near me'}
        </IonButton>
        {locationStatus === 'denied' && (
          <p className="nearby-casinos__hint body-small">
            Location access is turned off. Allow location for SlotCheck in your browser or device
            settings to see casinos near you.
          </p>
        )}
        {locationStatus === 'unavailable' && (
          <p className="nearby-casinos__hint body-small">
            We couldn&apos;t get your location. Please try again.
          </p>
        )}
      </div>
    );
  };

  return (
    <IonPage className="app-parent choose-casinos-page">
      <IonContent className="casino-content">
        <LegalDisclaimer isOpen={showModal} onClose={handleLegalDisclaimerClose} />
        <SmartLoading loading={isLoading} />
        {!isLoading && (
          <div className="container casino-container">
            <div className="casino-container__bottom-img">
              <IonImg src="assets/images/bgcoin-linkplayer.png" alt="" />
            </div>
            {(() => {
              // Prefer the device-local selection; fall back to the server's
              // most-recently-visited casino so the highlight persists across
              // logout and new devices.
              const lastSelectedCasino =
                (casinoSchema?.casinoId
                  ? (casinos.find((c) => c.casinoId === casinoSchema.casinoId) ?? null)
                  : null) ??
                (lastVisitedCasinoId
                  ? (casinos.find((c) => c.casinoId === lastVisitedCasinoId) ?? null)
                  : null);

              const exploreCasinos = sortByUserDistance(
                lastSelectedCasino
                  ? casinos.filter((c) => c.casinoId !== lastSelectedCasino.casinoId)
                  : casinos
              );

              return (
                <>
                  {/* Fixed top region: header + profile + the selected casino.
                      Stays pinned while the casino list scrolls underneath. */}
                  <div className="casino-fixed-top">
                    <div className="casino-fixed-top__nav">
                      <CasinoNavBar hideSearch hideLogo isDarkMode />
                    </div>
                    <IonGrid className="ion-no-margin m-signup m-signup__choose-casino">
                      <div className="choose-casinos my-casinos">
                        <div className="welcome-text">
                          <div
                            className="avatar"
                            style={
                              avatarId && avatarBgId
                                ? {
                                    backgroundImage: `url(${S3_PROFILE_BASE}/avatar-bg${avatarBgId}.png)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                  }
                                : undefined
                            }
                          >
                            {avatarId ? (
                              <img
                                src={`${S3_PROFILE_BASE}/avatar${avatarId}.png`}
                                alt="avatar"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                              />
                            ) : (
                              aliasInitial2 || ''
                            )}
                          </div>
                          <span>
                            Welcome{welcomeName ? <>, <span className="alias-name">{welcomeName}</span></> : ''}
                          </span>
                        </div>
                        {lastSelectedCasino && (
                          <>
                            {renderTitleContainer(lastSelectedCasino.displayName, true)}
                            {renderCasinoItem(lastSelectedCasino, 'casino-last-selected', true)}
                          </>
                        )}
                      </div>
                    </IonGrid>
                  </div>

                  {/* Scrolling region: only the section titles + cards move. */}
                  <IonGrid className="ion-no-margin m-signup m-signup__choose-casino">
                    <div className="choose-casinos my-casinos casino-scroll-list">
                      {renderNearbySection()}

                      {lastSelectedCasino && exploreCasinos.length > 0 && (
                        <>
                          {renderTitleContainer('Explore Other Casinos', false, 'explore-title')}
                          {exploreCasinos.map((eachCasino, index) =>
                            renderCasinoItem(eachCasino, `casino-key-${index}`)
                          )}
                        </>
                      )}

                      {!lastSelectedCasino && casinos.length > 0 && (
                        <>
                          {renderTitleContainer('Choose a Casino')}
                          {exploreCasinos.map((eachCasino, index) =>
                            renderCasinoItem(eachCasino, `casino-key-${index}`)
                          )}
                        </>
                      )}

                      {comingSoonCasinos.length >= 1 && (
                        <>
                          {renderTitleContainer('Coming Soon')}
                          {sortByUserDistance(comingSoonCasinos).map((casino, index) =>
                            renderCasinoItem(casino, `casino-soon-key-${index}`)
                          )}
                        </>
                      )}
                    </div>
                  </IonGrid>
                </>
              );
            })()}
          </div>
        )}
      </IonContent>
      
    </IonPage>
  );
};
